import { Flex, Skeleton } from 'antd'

export const SkeletonFilter = () => {
  const { Button } = Skeleton
  return (
    <Flex gap={16}>
      <Button key="1" style={{ width: 160 }} />
      <Button key="2" style={{ width: 250 }} />
      <Button key="3" style={{ width: 130 }} />
      <Button key="3" style={{ width: 250 }} />
      <Button key="5" style={{ width: 110 }} />
      <div style={{ height: 55 }}></div>
    </Flex>
  )
}
